<template>
  <div class='fucai'>
    <div class="kv">
      <img src="@/assets/family/fucai/kv.png" alt="">
    </div>
    <div class="container">
      <div class="title">产品列表</div>
      <div class="content">
        <div class="items" v-for="(item, index) in dataList" :key="index" @click="goinfo(item)">
          <img class="image" :src="JSON.parse(item.mp_logo_pic)[0].url" alt="">
          <div class="cover">查看详情</div>
          <div class="info">
            <div class="name">{{item.color_code}}</div>
            <div class="desc">{{item.color_desc}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGrainList } from '@/api/product.js'
export default {
  name: 'FuCai',
  components:{ 
  },
  data() {
    return {
      form: {
        product_id: 9 ,
        pageNum: 1,
        pageSize: 8
      },
      dataList: []
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.init()
  },
  mounted() {
      
  },
  methods: {
    init() {
      getGrainList({
        ...this.form
      }).then(res => {
        this.dataList = res.dataList
      })
    },

    goinfo(item) {
      this.$router.push({ path: '/family/fucai/info' , query: { id: item.id } })
    }
  }
}
</script>
<style lang='less' scoped>
.fucai {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .kv {
    width: 100%;
    max-width: 1920px;
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
  .container {
    width: 1440px;
    margin: 60px auto;
    .title {
      width: 160px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #009538;
      font-size: 24px;
      font-family: FZLanTingHeiS-DB-GB;
      font-weight: 400;
      color: #FFFFFF;
      border-radius: 20px 0 20px 0;
    }
    .content {
      width: 100%;
      margin-top: 30px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      -webkit-user-select: none;
      flex-wrap: wrap;
      .items {
        width: 450px;
        height: 600px;
        position: relative;
        margin-right: 44.5px;
        &:nth-of-type(3) {
          margin-right: 0;
        }
        .image {
          width: 450px;
          height: 450px;
          vertical-align: top;
          object-fit: cover;
        }
        .cover {
          width: 450px;
          height: 450px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0,0,0,.4);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 36px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          opacity: 0;
          transition: all 0.5s linear;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .name {
            font-size: 40px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 400;
            color: #4E8B46;
            line-height: 53px;
            margin-top: 15px;
          }
          .desc {
            font-size: 24px;
            font-family: FZLanTingHeiS-R-GB;
            font-weight: 400;
            color: #595858;
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>